import { createFileRoute } from '@tanstack/react-router'
import Banner from '../../components/Banner'
import Breadcrumb from '../../components/Breadcrumb'
import CardLayout1 from '../../components/CardLayout1'
import { getFlightsByContinent } from '../../services/API'
import { formatLabel } from '../../imageUrl'

export const Route = createFileRoute('/$level1/')({
  loader: async ({ params }) => {
    const data = await getFlightsByContinent(params.level1)
    return data
  },
  component: Level1Page,
})

function Level1Page() {
  const { level1 } = Route.useParams()
  const { flights, destination } = Route.useLoaderData()

  const continentName = flights[0]?.adv_cont ?? level1
  const destinations = flights[0]?.destinations ?? []
  const introCopy = destination?.IntroCopyStopOver || destination?.introCopy1
  const bannerImage = destination?.ImageLink ?? ''

  return (
    <div className="d-flex flex-column container-fluid p-0">
      <title>{formatLabel(continentName)} Flights | Trailfinders</title>
      <Breadcrumb items={[{ label: continentName }]} />

      <Banner title={`Flights To ${continentName}`} image={bannerImage} />

      <section className="container-fluid bg-light py-5">
        <div className="container">

          {introCopy && (
            <div className="row justify-content-center mb-5">
              <div className="col-12 col-sm-8 text-center">
                <p className="h6" dangerouslySetInnerHTML={{ __html: introCopy }} />
              </div>
            </div>
          )}

          <div className="row g-4 justify-content-center">
            {destinations.filter(d => d.ImageLink).map((dest, i) => (
              <div key={i} className="col-12 col-sm-6 col-md-4 col-lg-3">
                <CardLayout1
                  image={dest.ImageLink!}
                  title={dest.adv_dest}
                  introduction=""
                  href={dest.DocumentLink ?? '#'}
                  tourType=""
                  duration=""
                />
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <a
              href={`/holidays/${level1}`}
              className="btn btn-dark rounded-0 btn-lg px-5"
            >
              View all our holidays in {continentName}
            </a>
          </div>

        </div>
      </section>
    </div>
  )
}
